/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    homework_session_id: number;
    type: number; // 0全部，1只看讲师，2只是个人的
    student_id?: number; // 只看个人时，传的 student_id
}
export interface ITimelineCommentData {
    user_name: string;
    is_teacher: number;
    student_id: string;
    comment: {
        time_point: string; // 点评的时间点
        comment_type: string; // 1非常棒，2待改进，3文字点评，4语音点评
        operation: string; // 1增加点评，2删除点评
        id: string; // 点评的 id
        data: {
            // 文字/语音点评内容{语音点评包括 url 和 duration 的 数据 {
            content: string; // 语音点评资源 url
            duration: string; // 语音点评资源时长
            is_praise: string; // 1 normal2 like3 hate
        };
        permission: string; // 0公开；1私密
    };
}
interface IOutput {
    list: ITimelineCommentData[];
}

export const getTimelineCommentList = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.TIMELINE_COMMENT_LIST, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});
